module.exports = __webpack_public_path__ + "img/banner_usdt.5a123782.png";